<script setup lang="ts">
/**
 * /c — 魔導士の名のり の入口 (#417)
 *
 * 名のりの作成・編集は MagicianProfileEditDialog に統合されたので、
 * このページ自体はフォームを持たず、状態に応じて適切な遷移を行う:
 *
 * - 未認証 → /signin にリダイレクト
 * - 認証済 + slug あり → /c/<slug> へリダイレクト
 * - 認証済 + slug 未設定 → /adventurerscamp?edit=profile へリダイレクトし、
 *   そちらで編集ダイアログを自動的に開く
 */

definePageMeta({
  layout: 'landing',
})

useSeoMeta({
  title: '魔導士の名のり | Code & Magic',
})

const { isAuthenticated } = useAuthInfo()
const { user: userInfo } = storeToRefs(useGameStateStore())

// CSR で適切な行き先を決めて redirect する。SSR では何もしない (auth 情報
// が無いため)。
if (import.meta.client) {
  watchEffect(async () => {
    if (!isAuthenticated) {
      await navigateTo('/signin?redirect=/c', { replace: true })
      return
    }
    if (userInfo.value?.slug) {
      await navigateTo(`/c/${userInfo.value.slug}`, { replace: true })
      return
    }
    // 認証済だが slug 未設定 → キャンプで編集ダイアログを開く
    await navigateTo('/adventurerscamp?edit=profile', { replace: true })
  })
}
</script>

<template>
  <div class="c-redirect">
    <p class="c-redirect__msg">
      移動中…
    </p>
  </div>
</template>

<style scoped>
.c-redirect {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 40dvh;
}

.c-redirect__msg {
  font-family: "Utsukushi", "Noto Sans JP", serif;
  color: #5c2c0c;
  opacity: 0.7;
}
</style>
